function updatePersonalizationVariantPrice(event) {
  const buttonEl = event.currentTarget;
  const container = document.querySelector('.selected-variant-option-dropdown');
  if (!container) return;

  const price = buttonEl.getAttribute('data-variant-price');
  const priceFiltered = Number(buttonEl.getAttribute('data-variant-price-filtered'));
  const priceTarget = container.querySelector('#selected-option-placeholder');

  if (priceTarget && price) {
    priceTarget.textContent = priceFiltered > 0 ? `+${price}` : '';
  }

  let maxLength = buttonEl.getAttribute('data-variant-max-length');
  
  // Si la opción seleccionada es "Nombre completo", limitar a 8 caracteres
  const selectedValue = buttonEl.getAttribute('value') || buttonEl.getAttribute('title') || '';
  if (selectedValue.toLowerCase().includes('nombre completo')) {
    maxLength = '8';
  }
  
  const toggleInput = buttonEl.getAttribute('data-variant-show-input') === 'true';
  toggleInputLineItem(toggleInput, maxLength);    
}

function toggleInputLineItem(show, maxLength) {
  const inputContainer = document.querySelector('.personalization-text-line-item');
  if (!inputContainer) return;

  const inputEl = inputContainer.querySelector('input');
  if (!inputEl) return;

  inputEl.value = '';

  if (show) {
    (maxLength && maxLength > 0) ? inputEl.setAttribute('maxlength', maxLength) : inputEl.removeAttribute('maxlength');
    inputEl.setAttribute('required', 'required');
  } else {
    inputEl.removeAttribute('maxlength');
    inputEl.removeAttribute('required');
  }

  inputContainer.classList.toggle('hidden', !show);
}


async function removeItemsByRefId(event, refId) {
  event.preventDefault();
  if (!refId) return;

  try {
    // Get current cart
    const cart = await fetch(`${Shopify.routes.root}cart.js`).then(r => r.json());

    // Build updates object: set qty=0 for all items with same refId
    const updates = {};
    cart.items.forEach(item => {
      if (item.properties && item.properties._refId === refId) {
        updates[item.key] = 0;
      }
    });

    if (Object.keys(updates).length === 0) return;

    // Send update
    const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });

    const updatedCart = await response.json();

    // Trigger theme events so UI refreshes
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', { 
        bubbles: true, 
        detail: { baseEvent: 'remove:refId', cart: updatedCart } 
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', { 
        bubbles: true, 
        detail: { cart: updatedCart } 
      })
    );
  } catch (err) {
    console.error('Failed to remove items by refId', err);
  }
}

/**
 * Limpia personalizaciones huérfanas del carrito.
 * Una personalización huérfana es aquella que tiene _isPersonalization pero no tiene
 * un producto principal asociado con el mismo _refId.
 */
let isCleaningOrphaned = false;
async function cleanOrphanedPersonalizations() {
  // Evitar loops infinitos
  if (isCleaningOrphaned) return;
  
  try {
    isCleaningOrphaned = true;
    // Get current cart
    const cart = await fetch(`${Shopify.routes.root}cart.js`).then(r => r.json());
    
    if (!cart.items || cart.items.length === 0) {
      isCleaningOrphaned = false;
      return;
    }
    
    // Group items by refId
    const itemsByRefId = {};
    cart.items.forEach(item => {
      if (item.properties && item.properties._refId) {
        const refId = item.properties._refId;
        if (!itemsByRefId[refId]) {
          itemsByRefId[refId] = [];
        }
        itemsByRefId[refId].push(item);
      }
    });
    
    // Find orphaned personalizations
    const updates = {};
    
    // Check for personalizations without _refId (legacy issue)
    cart.items.forEach(item => {
      if (item.properties && 
          item.properties._isPersonalization === 'true' && 
          (!item.properties._refId || item.properties._refId === '')) {
        updates[item.key] = 0;
      }
    });
    
    // Check each refId group
    Object.keys(itemsByRefId).forEach(refId => {
      const items = itemsByRefId[refId];
      const hasPersonalization = items.some(item => 
        item.properties && item.properties._isPersonalization === 'true'
      );
      const hasMainProduct = items.some(item => 
        item.properties && item.properties._isPersonalization !== 'true'
      );
      
      // If there's a personalization but no main product, remove the personalization
      if (hasPersonalization && !hasMainProduct) {
        items.forEach(item => {
          if (item.properties && item.properties._isPersonalization === 'true') {
            updates[item.key] = 0;
          }
        });
      }
    });
    
    if (Object.keys(updates).length === 0) {
      isCleaningOrphaned = false;
      return;
    }
    
    // Remove orphaned items
    const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
    
    if (!response.ok) {
      console.error('Failed to clean orphaned personalizations');
      isCleaningOrphaned = false;
      return;
    }
    
    const updatedCart = await response.json();
    
    // Trigger theme events so UI refreshes (usar setTimeout para evitar loop)
    setTimeout(() => {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', { 
          bubbles: true, 
          detail: { baseEvent: 'clean:orphaned', cart: updatedCart } 
        })
      );
      
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { 
          bubbles: true, 
          detail: { cart: updatedCart } 
        })
      );
      isCleaningOrphaned = false;
    }, 100);
  } catch (err) {
    console.error('Failed to clean orphaned personalizations', err);
    isCleaningOrphaned = false;
  }
}

// Listen to cart changes to clean orphaned personalizations
if (typeof document !== 'undefined') {
  document.addEventListener('cart:change', (event) => {
    // No ejecutar si el evento viene de nuestra propia limpieza
    if (event.detail && event.detail.baseEvent === 'clean:orphaned') {
      return;
    }
    cleanOrphanedPersonalizations();
  });
  document.addEventListener('cart:refresh', cleanOrphanedPersonalizations);
}